import React from "react";
import { InterpolateWithLinks } from "components/Checkout/components/InterpolateWithLinks";
import { termsAndConditionsWrapper } from "./TermsAndConditions.css";
import type { ThresholdProgressResult } from "../thresholds";

export const ThresholdTermsAndConditions = ({
  thresholds
}: {
  thresholds: ThresholdProgressResult[];
}): React.JSX.Element => {
  if (!thresholds?.length) return <></>;

  return (
    <>
      {thresholds.map((threshold) => {
        if (!threshold?.progressBanner?.termsAndConditions) {
          return null;
        }
        return (
          <div
            key={threshold.progressBanner.copy}
            className={termsAndConditionsWrapper}
            data-testid="free-shipping-t&cs"
          >
            <InterpolateWithLinks
              data={threshold.progressBanner.termsAndConditions}
            />
          </div>
        );
      })}
    </>
  );
};
